import React from "react";
import Select, { components } from "react-select";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  width: 100%;
`;

/**
 *
 * User : 이연우
 * Date : 2023.05.04
 * @ file : CpmCommSelect.js
 * @ Desc : Select 공통 Component
 * @param {Array} options 데이터 [{label: string, value: any}]
 * @param {boolean} isSearchable 검색 기능 YN
 * @param {string} placeholder placeholder
 * @param {[{label, value}]} select 선택한 select 데이터
 * @param {Function} onChangeSelect select 값 변경 함수
 * @param {Function} onChangeInput input 값 변경 함수
 * @param {boolean} isDisabled - disabled Yn
 */
const CpmCommSelect = ({
  options = [],
  isSearchable = true,
  placeholder = "",
  select,
  onChangeSelect = () => {},
  onChangeInput = () => {},
  selectRef,
  isDisabled,
  essential = false,
  name,
}) => {
  return (
    <StyledSelect
      className={`checkValidate ${essential && 'essential'} label${name}label`}
      value={select}
      onChange={onChangeSelect}
      onInputChange={onChangeInput}
      options={options}
      placeholder={placeholder}
      isSearchable={isSearchable}
      styles={selectCustom}
      components={{ Option: optionCustom }}
      noOptionsMessage={() => null}
      ref={selectRef}
      isDisabled={isDisabled}
      id={name}
    />
  );
};

export default CpmCommSelect;

// Style
const selectCustom = {
  control: (base, state) => ({
    ...base,
    minHeight: "calc(1.5em + 0.5rem)",
    height: "calc(1.5em + 0.5rem)",
    width: "100%",
    borderRadius: 4,
    boxShadow: "none",
    cursor: "pointer",
    fontSize: `0.9rem * 0.875`,
    boxSizing: "border-box",
    color: state.isDisabled ? 'var(--vz-body-color)' : '',
    backgroundColor: state.isDisabled ? 'var(--vz-input-disabled-bg)' : 'var(--vz-input-bg)',
    border: state.isDisabled ? '1px solid var(--vz-input-border)' : '',
    "& svg": {
      height: "calc(1.5em + 0.5rem)",
      padding: 0,
      transition: "All .3s",
      transform: state.menuIsOpen ? "rotate(-180deg)" : "rotate(0)",
    },
    "& > .select__value-container": {
      padding: 0,
      paddingLeft: 2,
    },
  }),
  option: (base) => ({
    ...base,
    cursor: "pointer",
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    height:200
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 0,
    paddingRight: 2,
  }),
  valueContainer: (base) => ({
    ...base,
    minHeight: "calc(1.5em + 0.5rem - 2px)",
    height: "calc(1.5em + 0.5rem - 2px)",
    boxSizing: "border-box",
  }),
  input: (base) => ({
    ...base,
    minHeight: "calc(1.5em)",
    height: "calc(1.5em)",
    boxSizing: "border-box",
    fontSize: "0.7875rem",
  }),
};

// dropDown Style
const optionCustom = ({ children, ...props }) => {
  const input = props.selectProps.inputValue;
  const option = props.data.label;
  const index = option.indexOf(input);
  const len = input.length;
  return (
    <components.Option {...props}>
      <span>{option.substr(0, index)}</span>
      <span className="text-danger">{input}</span>
      <span>{option.substr(index + len)}</span>
    </components.Option>
  );
};
